(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["variant-picker"] && !Shopify.designMode) return;
  try {
    const optionData = document.getElementById('bundle-option-data');
  const moriOptionIndex = optionData.dataset.moriOptionIndex;
  const protectorOptionIndex = optionData.dataset.protectorOptionIndex;
  const hideAccordion = () => {
    document.querySelectorAll('.accordion').forEach((accordion) => {
      const hasText = accordion.textContent.includes('Take Mattress Protector (Size)');

      if (hasText) {
        accordion.style.display = 'none';
      }
    });
  };

  const observer = new MutationObserver(() => {
    hideAccordion();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });

  window.addEventListener('load', hideAccordion);

  document.addEventListener('change', function (e) {
    const target = e.target;

    if (!moriOptionIndex || !protectorOptionIndex) return;
    // Mori Sheet Set option
    if (target.name === `option${moriOptionIndex}`) {
      const selectedValue = target.value;

      // Find hidden option input of Take Mattress Protector
      const protectorInput = document.querySelector(`[name="option${protectorOptionIndex}"]`);

      if (protectorInput) {
        protectorInput.value = selectedValue;

        // trigger change to Shopify update variant
        protectorInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  });
  } catch(e) { console.error(e); }
})();

})();
